export const pricingNameRoot = 'pricing';
